module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA GAZOWA.6e4ec472.svg";